export function translate(value, language) {

    if (!value) {
        return ''
    }

    if (typeof value === 'string') {
        return value
    }

    return value[language] || value.fr || ''
}